import React from 'react';
import { FocusScope } from '@react-aria/focus';
import { DismissButton } from '@react-aria/overlays';
import cn from 'classnames';

import { ComboBoxDesktopDropdownProps } from '../../types/comboBoxComponentTypes';

import { Portal } from '../Portal';

export const ComboBoxDesktopDropdown: React.FC<ComboBoxDesktopDropdownProps> = ({
  inputId,
  containerRef,
  popoverRef,
  positionStyles,
  animationClasses,
  maxHeight,
  shouldShowStickyButton,
  isCurrentlyLoading,
  loadingState,
  loadingContent,
  optionsList,
  addItemButton,
  onClose
}) => (
  <Portal>
    <FocusScope contain restoreFocus autoFocus={false}>
      <div
        ref={popoverRef}
        id={`${inputId}-listbox`}
        className={cn(
          'bg-white border border-lightBlueGray300 rounded-lg shadow-lg flex flex-col box-border',
          animationClasses,
          'base__dropdown'
        )}
        style={{
          ...positionStyles,
          width: containerRef.current?.offsetWidth,
          maxHeight: shouldShowStickyButton
            ? `${maxHeight}px`
            : `${maxHeight + 80}px`,
          zIndex: 9999
        }}
      >
        <DismissButton onDismiss={onClose} />

        {isCurrentlyLoading && loadingState !== 'loadingMore'
          ? loadingContent
          : optionsList}

        {loadingState === 'loadingMore' && (
          <div className="p-2 text-center text-sm text-cement border-t border-lightBlueGray300">
            <svg
              className="w-4 h-4 mx-auto animate-spin"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="#475569"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
            <span className="mt-1 block">Loading more...</span>
          </div>
        )}

        {addItemButton}

        <DismissButton onDismiss={onClose} />
      </div>
    </FocusScope>
  </Portal>
);

ComboBoxDesktopDropdown.displayName = 'ComboBoxDesktopDropdown';
